import React, { useEffect, useState } from 'react';
import { ZigInputCode, ZigButton, ZigTypography } from '@zignaly-open/ui';
import { useTranslation } from 'react-i18next';
import { Layout, Field } from './styles';
import { EmailVerifyFormProps } from './types';
import { Box } from '@mui/material';

function EmailVerifyForm({
  onSubmit,
  onChange,
  onReSendCode,
  clearOnError,
  isLoading,
  error = null,
  isReSendLoading = false,
  prefixId,
  autoFocus = true,
}: EmailVerifyFormProps) {
  const { t } = useTranslation('auth');
  const [canResend, setCanResend] = useState(false);
  const delayedSetCanResendTrue = () =>
    setTimeout(() => setCanResend(true), 5000);

  useEffect(() => {
    delayedSetCanResendTrue();
  }, []);

  return (
    <Layout>
      <Field>
        <Box display={'flex'} flexDirection={'column'} gap={1}>
          <ZigTypography variant={'body1'} id={`${prefixId}__description`}>
            {t('login-form.verifyEmail.title')}
          </ZigTypography>
          <ZigTypography variant={'body2'} id={`${prefixId}__spam`}>
            {t('login-form.verifyEmail.spam')}
          </ZigTypography>
        </Box>
        <ZigInputCode
          prefixId={prefixId}
          fields={6}
          error={error}
          loading={isLoading}
          clearOnError={clearOnError}
          onComplete={onSubmit}
          onChange={onChange}
          autoFocus={autoFocus}
          autoComplete='off'
        />
        <Box
          sx={{
            // fix for the loader rotating and causing a seizure for the modal
            minHeight: '28px',
          }}
        >
          <ZigButton
            id={`${prefixId}__resend-code`}
            variant={'text'}
            disabled={!canResend && !isReSendLoading}
            tooltip={
              !canResend && !isReSendLoading
                ? t('login-form.resend-wait')
                : null
            }
            onClick={() => {
              setCanResend(false);
              delayedSetCanResendTrue();
              onReSendCode();
            }}
            loading={isReSendLoading}
          >
            {t('login-form.verifyEmail.button')}
          </ZigButton>
        </Box>
      </Field>
    </Layout>
  );
}

export default EmailVerifyForm;
